module.exports = __webpack_public_path__ + "45055c48ddb3d40e13265dcc8847d169.png";